export const mountableSteps = {
	stepLabel: "Étape",
	addStep: "Ajouter une nouvelle étape",
	removeStep: "Supprimer l'étape",
	reorderStep: "Réorganiser l'étape",
	itemStatus: {
		active: "Article actif",
		inactive: "Article inactif",
		modal: {
			title: {
				activate: "Activer l'article montable",
				deactivate: "Désactiver l'article montable",
			},
			message: {
				activate:
					"Si cet article compose aussi d'autres produits montables, voulez-vous l'activer dans tous ?",
				deactivate:
					"Si cet article compose aussi d'autres produits montables, voulez-vous le désactiver dans tous ?",
			},
		},
	},
	emptyState: {
		title: "Commencez par ajouter une nouvelle étape",
		description:
			"Les étapes permettent au client de choisir la cuisson de la viande, les accompagnements, les suppléments, etc.",
	},
	cardHeader: {
		titlePlaceholder: "Nom de l'étape",
	},
	fields: {
		title: {
			label: "Titre",
			placeholder: "Entrez le titre de l'étape",
		},
		pricing: {
			label: "Tarification",
			placeholder: "Choisissez le modèle tarifaire pour cette étape",
			options: {
				sum: {
					label: "Supplémentaire",
					tooltip: "Chaque élément ajouté sera incrémenté dans la valeur du produit",
				},
				average: {
					label: "Moyenne",
					tooltip: "La moyenne des éléments sélectionnés sera incrémentée",
				},
				higher: {
					label: "Valeur la plus élevée",
					tooltip:
						"La valeur la plus élevée parmi les éléments sera ajoutée à la valeur du produit",
				},
			},
		},
		min: {
			label: "Qté min sélectionnable de l'étape",
			tooltip: "Minimum d'articles à sélectionner dans cette étape",
		},
		max: {
			label: "Qté max sélectionnable de l'étape",
			tooltip: "Maximum d'articles à sélectionner dans cette étape",
		},
	},
	fiscalSplit: {
		switchLabel: "Division fiscale",
		enabled: "Division fiscale activée",
		disabled: "Division fiscale désactivée",
		title: "DIVISION FISCALE",
		fiscalWeight: {
			label: "% Poids fiscal de l'étape {{stepNumber}}",
			placeholder: "00%",
			info: "Le poids (%) détermine la part de cette étape sur la facture.",
			supplyAlert: {
				title: "Il y a des approvisionnements dans cette étape",
				message:
					"Lorsque l'étape contient des produits et des approvisionnements, le poids fiscal (%) définit uniquement la part des produits avec des données fiscales sur la facture. Les approvisionnements ci-dessus n'ont pas de données fiscales et ne seront pas émis.",
			},
		},
		summary: {
			title: "Résumé fiscal",
			stepPrefix: "Étape",
			incomplete: "répartissez 100% entre les étapes",
		},
		dialog: {
			triggerLabel: "En savoir plus sur la division fiscale",
			title: "Division fiscale",
			paragraph1:
				"La division fiscale définit comment la valeur totale de la facture est répartie entre les éléments du produit montable.",
			paragraph2: {
				intro:
					"Les poids (%) des étapes déterminent la part des produits avec des données fiscales sur la facture.",
				bold:
					"Les approvisionnements n'ont pas de données fiscales et ne seront pas émis sur la facture finale.",
			},
			example: {
				title: "Exemple :",
				intro: "Une caipirinha de R$ 20 :",
				item1: "Base (70 %) — cachaça (produit avec données fiscales) : R$ 14",
				item2:
					"Compléments (30 %) — sucre (approvisionnement) et citron vert (approvisionnement) : non émis",
				conclusion:
					"Dans ce cas, seule la cachaça participe à la division de la valeur de la facture.",
			},
			close: "Fermer",
			confirm: "Compris",
		},
	},
	itemsSection: {
		title: "ARTICLES SUPPLÉMENTAIRES",
		addItem: "Ajouter un autre article",
		removeItem: "Supprimer l'article",
		clearItem: "Vider l'article",
		fields: {
			item: {
				label: "Article",
				placeholder: "Sélectionnez un article",
				loadingPlaceholder: "Chargement des produits...",
			},
			price: {
				label: "Prix",
				placeholder: "0,00",
				tooltip:
					"Valeur suggérée à partir du prix enregistré du produit. Les modifications effectuées ici s'appliquent uniquement à cet enregistrement et ne modifient pas le prix d'origine du produit.",
				clear: "Effacer",
			},
			maxCount: {
				label: "Qté max de l'article",
				placeholder: "0",
				tooltip:
					"Nombre maximum de fois que cet article peut être sélectionné dans l'étape",
			},
			storageCount: {
				label: "Qté déduite de l'article",
				placeholder: "0",
				tooltip: "Quantité à déduire du stock par unité",
			},
			isModification: {
				label: "Article de modification",
			},
		},
	},
	actions: {
		delete: "Supprimer le produit montable",
		clear: "Effacer le produit montable",
		deleteConfirmation: {
			title: "Supprimer le produit montable",
			description:
				"En confirmant cette action vous supprimez définitivement le produit montable. Voulez-vous continuer ?",
			confirm: "Oui, je veux supprimer",
			cancel: "Annuler",
		},
		clearConfirmation: {
			title: "Effacer le produit montable",
			description:
				"En confirmant cette action vous effacez toutes les données du produit montable du formulaire. Voulez-vous continuer ?",
			confirm: "Oui, je veux effacer",
			cancel: "Annuler",
		},
		notifications: {
			deleteSuccess: "Produit montable supprimé avec succès",
			deleteError: "Erreur lors de la suppression du produit montable",
		},
	},
	preview: {
		toggle: {
			pdv: "Caisse",
			totem: "Borne",
		},
		productNameFallback: "Nom du produit",
		descriptionFallback:
			"Ajoutez une description du produit qui sera affichée sur la caisse ou la borne.",
		seeMore: "Voir plus",
		requiredBadge: "Obligatoire",
		stepFallbackTitle: "Étape {{n}}",
		itemFallbackName: "Article",
		chooseUpToOne: "Choisissez jusqu'à {{count}} article",
		chooseUpToMany: "Choisissez jusqu'à {{count}} articles",
		addCta: "Ajouter {{total}}",
		empty: {
			title: "Aperçu",
			description:
				"Les étapes apparaîtront ici au fur et à mesure que vous remplirez le formulaire.",
		},
		illustrativeNotice:
			"Cet aperçu est illustratif et peut différer de l'affichage réel sur la caisse ou la borne.",
		previewActionTooltip: "Aperçu uniquement — les actions ne sont pas disponibles ici.",
		expandPreview: "Agrandir l'aperçu",
	},
};
